<template>
  <div class="c-main">
    <div class="c-insertText--top1" v-if="isInsertTextReady">
      <common-auto-link class="c-insertText--top1__text" v-for="(item, index) in modifiableText.top1" :key="index" :text="item"></common-auto-link>
    </div>
    <section class="c-main--screen" :style="{'background-image': 'url(' + bg + ')'}">
      <h1>おトクな不動産が見つかる <img src="@/assets/logo-without-slogan.png" width="" alt="ミツカル"></h1>
      <div class="c-main--screen--area">
        <div class="c-main--screen--area--wrap">
          <div>
            <select v-model="selectedPrefecture" class="c-main--screen--area--wrap__list">
              <option value="0">都道府県</option>
              <option v-for="(item, index) in preflist" :key="index" :value="item.pref_code">{{item.pref_name}}</option>
            </select>
          </div>
          <div>
            <select v-model="selectedCity" class="c-main--screen--area--wrap__list" :disabled="!isCityReady">
              <option value="0">市区町村</option>
              <option v-for="(item, index) in citylist" :key="index" :value="item.city_code">{{item.city_name}}</option>
            </select>
          </div>
        </div>
        <button class="c-main--screen--area--submit" @click="onClickSearch"><img :src="require('@/assets/icon-search-history-2.png')"></button>
      </div>
    </section>
    <div class="c-insertText--top2" v-if="isInsertTextReady">
      <common-auto-link class="c-insertText--top2__text" v-for="(item, index) in modifiableText.top2" :key="index" :text="item"></common-auto-link>
    </div>
    <section v-if="sugguestProperties.length > 0" class="c-main__AreaList">
      <h2 class="c-main__AreaList__heading" >エリアから探す</h2>
      <ul class="c-main__AreaList__list">
        <li class="c-main__AreaList__list__item" v-for="(item, index) in preflist " :key="index">
          <a :href="`/kodate/area/${item.pref_code}/`" >{{`${item.pref_name}(${+item.count.toLocaleString()})`}}</a>
        </li>
      </ul>
    </section>
    <section v-if="sugguestProperties.length > 0" class="c-main__SugguestProperty">
      <h2 class="c-main__SugguestProperty__heading" >おトクなおすすめ物件</h2>
      <p class="c-main__SugguestProperty__text">物件を探すほど、あなたにおすすめな物件を表示します。</p>
      <ul class="c-main__SugguestProperty__list">
        <li class="c-main__SugguestProperty__list__item" v-for="(item, index) in sugguestProperties " :key="index">
          <common-property-card :propdata="item.fields" :isFavorite="true" :mode="'prod'" /></li>
      </ul>
    </section>
    <section class="c-main--suggest">
      <div class="c-main--suggest--movie" @click="openMovieModal">
        <div class="c-main--suggest--movie__item">
          <figure>
            <img :src="video.video_thumb_url">
          </figure>
          <article>
            <div>
              <h3 class="c-main--suggest--movie__item--heading">{{video.video_heading}}</h3>
              <p>{{video.video_text}}</p>
            </div>
            <a :href="video.video_link_url" target="_blank" @click="openMoviePage">{{video.video_link}}</a>
          </article>
        </div>
      </div>
      <!-- <h2>もう迷わない。暮らし方から、見つける家探し</h2> -->
      <ul class="c-main--suggest--list">
        <li class="c-main--suggest--list__itemWrapper" v-for="(item, index) in suggest.data.contents" :key="index">
          <a  class="c-main--suggest--list__item" :href="item.url">
            <figure>
              <img :src="item.media.url">
            </figure>
            <article>
              <div>
                <h3>{{item.sub}}</h3>
                <p>{{item.title}}</p>
              </div>
              <div class="c-main--suggest--list__item__flex">
                <span>{{item.areaname}}</span>
                <common-button
                  v-if="!isMobile"
                  :title="'一覧を表示する'"
                  :type="'link'"
                  :link_url="item.url"
                  :border_gray="true"
                  :small="true"
                  :no_width="true" />
              </div>
            </article>
          </a>
        </li>
      </ul>
    </section>
    <section class="c-main--school-search">
      <school-districts-list-search :preflist="preflist" :subtitle="true" class="search-wrapper">
        おトクな情報を探す
      </school-districts-list-search>
    </section>
    <div class="favarite-price-diff">
      <section class="c-main--favarite-price-diff">
        <h2>おトクな価格変更情報</h2>
        <div class="c-main--favarite-price-diff--list">
          <ul v-if="compareList.length > 0">
            <li v-for="i of [0, 1, 2, 3, 4]" :key="i">
                <p class="c-main--favarite-price-diff--list--date" v-if="compareList[i]">{{dateFormated(compareList[i].addedDate, 'YYYY.MM.DD')}}</p>
                <a v-if="compareList[i]" :href="`/kodate/${compareList[i].id}/`">
                  「{{compareList[i].name}}」の価格が
                  <span class="c-main--favarite-price-diff--list--red">{{compareList[i].oldPriceMin | manEn}}</span>から
                  <span class="c-main--favarite-price-diff--list--red">{{compareList[i].newPriceMin | manEn}}</span>に変更されました。
                </a>
                <p class="" v-if="compareList[i] && !isMobile">
                  <a class="" :href="`/kodate/${compareList[i].id}/`">
                    >
                  </a>
                </p>
            </li>
          </ul>
          <ul v-else>
            <li>
              <div class="c-main--nothing-favarite-price-diff">
                お気に入り登録している物件に価格変動があった場合は、こちらで通知いたします。
              </div>
            </li>
          </ul>
        </div>
      </section>
    </div>
    <section class="c-main--blog c-main--blog--top">
      <h2>おトクな住宅お役立ち情報</h2>
      <section class="c-main--blog--box">
        <h3>
          <img :src="require('@/assets/icon-house-top.png')">
          はじめての住宅購入
        </h3>
        <ul class="c-main--blog--box--list">
          <li class="" v-for="(item, index) in blog.new.data.contents" :key="index">
            <a :href="item.url">
              <figure>
                <img :src="item.thumbnail.url">
              </figure>
              <article>
                <h4>{{item.title}}</h4>
                <p>{{item.description}}</p>
              </article>
            </a>
          </li>
        </ul>
      </section>
      <section class="c-main--blog--box">
        <h3>
          <img :src="require('@/assets/icon-money.png')">
          住宅購入時に知っておきたいお金のコト
        </h3>
        <ul class="c-main--blog--box--list">
          <li class="" v-for="(item, index) in blog.money.data.contents" :key="index">
            <a :href="item.url">
              <figure>
                <img :src="item.thumbnail.url">
              </figure>
              <article>
                <h4>{{item.title}}</h4>
                <p>{{item.description}}</p>
              </article>
            </a>
          </li>
        </ul>
      </section>
      <!-- <section class="c-main--blog--box">
        <h3>
          <img :src="require('@/assets/icon-search-history.png')">
          タイプ別でわかる住まい探しのポイント
        </h3>
        <ul class="c-main--blog--box--list">
          <li class="" v-for="(item, index) in blog.conv.data.contents" :key="index">
            <a :href="item.url">
              <figure>
                <img :src="item.thumbnail.url">
              </figure>
              <article>
                <h4>{{item.title}}</h4>
                <p>{{item.description}}</p>
              </article>
            </a>
          </li>
        </ul>
      </section>

      <section class="c-main--blog--box">
        <h3>
          <img :src="require('@/assets/icon-balloon-top.png')">
          住まいのおトク情報
        </h3>
        <ul class="c-main--blog--box--list">
          <li class="" v-for="(item, index) in blog.question.data.contents" :key="index">
            <a :href="item.url">
              <figure>
                <img :src="item.thumbnail.url">
              </figure>
              <article>
                <h4>{{item.title}}</h4>
                <p>{{item.description}}</p>
              </article>
            </a>
          </li>
        </ul>
      </section> -->
    </section>
    <section class="c-main--blog c-main--blog--bottom">
      <h2 class="c-main--blog--merit">会員登録のメリット</h2>
      <section class="c-main--blog--box c-main--blog--box--nomargin">
        <ul class="c-main--blog--box--list">
          <li class="" v-for="(item, index) in blog.memberShip.data1.contents" :key="index">
            <a :href="item.url">
              <figure>
                <img :src="item.thumbnail.url">
              </figure>
              <article>
                <h4>{{item.title}}</h4>
                <p>{{item.description}}</p>
              </article>
            </a>
          </li>
        </ul>
      </section>
      <section class="c-main--blog--box c-main--blog--box--nomargin">
        <ul class="c-main--blog--box--list">
          <li class="" v-for="(item, index) in blog.memberShip.data2.contents" :key="index">
            <a :href="item.url">
              <figure>
                <img :src="item.thumbnail.url">
              </figure>
              <article>
                <h4>{{item.title}}</h4>
                <p>{{item.description}}</p>
              </article>
            </a>
          </li>
        </ul>
      </section>
    </section>
    <!-- <nav class="c-main--area">
      <h4>都道府県別の物件一覧はこちら</h4>
      <ul class="c-main--area--list">
        <li class="c-main--area--list__item" v-for="(item, index) in arealist" :key="index">
          <div class="c-main--area--list__item__key">{{item.name}}</div>
          <div class="c-main--area--list__item__value">
            <ul class="c-main--area--list__item__value__list">
              <li class="c-main--area--list__item__value__list__item" v-for="(city,idx) in item.list" :key="idx"><a :href="`/kodate/area/${city.code}`" >{{city.name}}</a></li>
            </ul>
          </div>
        </li>
      </ul>
    </nav> -->
    <nav class="c-main--kind">
      <h4>都道府県別の物件一覧はこちら</h4>
      <ul class="c-main--kind--list">
        <li class="c-main--kind--list__item">
          <div class="c-main--kind--list__item__key"><a href="/kodate/">一戸建て</a></div>
          <div class="c-main--kind--list__item__value">
            <ul class="c-main--kind--list__item__value__list" v-if="arealists.all">
              <li class="c-main--kind--list__item__value__list__item"><a href="/kodate/" >全てのエリア ({{arealists.all.map(n=>n.count).reduce((n,m)=>{return n+m}).toLocaleString()}})</a></li>
              <li class="c-main--kind--list__item__value__list__item" v-for="(item, index) in arealists.all" :key="index"><a :href="`/kodate/area/${item.pref_code}/`" >{{`${item.pref_name} (${+item.count.toLocaleString()})`}}</a></li>
            </ul>
          </div>
        </li>
        <li class="c-main--kind--list__item">
          <div class="c-main--kind--list__item__key"><a href="/kodate/shinchiku/">新築一戸建て</a></div>
          <div class="c-main--kind--list__item__value">
            <ul class="c-main--kind--list__item__value__list" v-if="arealists.shinchiku">
              <li class="c-main--kind--list__item__value__list__item"><a href="/kodate/shinchiku/" >全てのエリア ({{arealists.shinchiku.map(n=>n.count).reduce((n,m)=>{return n+m}).toLocaleString()}})</a></li>
              <li class="c-main--kind--list__item__value__list__item" v-for="(item, index) in arealists.shinchiku" :key="index"><a :href="`/kodate/shinchiku/area/${item.pref_code}/`" >{{`${item.pref_name} (${+item.count.toLocaleString()})`}}</a></li>
            </ul>
          </div>
        </li>
        <li class="c-main--kind--list__item">
          <div class="c-main--kind--list__item__key"><a href="/kodate/chuko/">中古一戸建て</a></div>
          <div class="c-main--kind--list__item__value">
            <ul class="c-main--kind--list__item__value__list" v-if="arealists.chuko">
              <li class="c-main--kind--list__item__value__list__item"><a href="/kodate/chuko/" >全てのエリア ({{arealists.chuko.map(n=>n.count).reduce((n,m)=>{return n+m}).toLocaleString()}})</a></li>
              <li class="c-main--kind--list__item__value__list__item" v-for="(item, index) in arealists.chuko" :key="index"><a :href="`/kodate/chuko/area/${item.pref_code}/`" >{{`${item.pref_name} (${+item.count.toLocaleString()})`}}</a></li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
    <div class="c-insertText--top3" v-if="isInsertTextReady">
      <common-auto-link class="c-insertText--top3__text" v-for="(item, index) in modifiableText.top3" :key="index" :text="item"></common-auto-link>
    </div>
    <transition name="modal-fade c-main--favarite-price-diff-modal">
      <div class="modal-mask" v-if="isShowModal">
        <div class="modal-wrapper c-main--favarite-price-diff-modal--modal-wrapper">
          <div class="modal-container c-main--favarite-price-diff-modal--container">
            <div @click="isShowModal = !isShowModal" class="modal-close-icon c-main--favarite-price-diff-modal--close">
              <img class="button-icon" src="@/assets/icon-close-button-original.png" alt="">
            </div>
            <div class="modal-content-wrapper">
              <div class="modal-header c-main--favarite-price-diff-modal--header">
                <h3>おトクな価格変更情報</h3>
              </div>
              <div class="c-main--favarite-price-diff-modal--list">
                <ul>
                  <li v-for="(item, index) in compareRowList" :key="index">
                      <p class="c-main--favarite-price-diff-modal--list--date">{{dateFormated(item.addedDate, 'YYYY.MM.DD')}}</p>
                      <div class="row-flex">
                        <a :href="`/kodate/${item.id}/`">
                          <span>「{{item.name}}」の価格が </span>
                          <span class="c-main--favarite-price-diff-modal--list--red">{{item.oldPriceMin | manEn}}</span>から
                          <span class="c-main--favarite-price-diff-modal--list--red">{{item.newPriceMin | manEn}}</span>に変更されました。
                        </a>
                        <a class="c-main--favarite-price-diff-modal--list--icon" :href="`/kodate/${item.id}/`">
                          >
                        </a>
                      </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="modal-fade c-main--movie-modal">
      <div class="modal-mask" v-if="isShowMovieModal" @click="closeMovieModal">
        <div class="modal-wrapper c-main--movie-modal--modal-wrapper">
          <div class="c-main--movie-modal--container">
            <div class="c-main--movie-modal--container--box">
              <iframe id="ytplayer" type="text/html"
                  :src="video.youtube_url"
                  frameborder="0"></iframe>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import Cookies from 'js-cookie';

import MixinUtil from '@/plugins/mixin-utils';
import MixinAPIs from '@/plugins/mixin-api';
import Meta from '@/plugins/mixin-meta';
import BehaviorLogMixin from '@/plugins/mixin-behavior-log';


import CommonGoToTop from '@/components/parts/CommonGoToTop';
import CommonAutoLink from '@/components/parts/CommonAutoLink';
import SchoolDistrictsListSearch from '@/components/search/school-districts/SchoolDistrictsListSearch';
import CommonPropertyCard from '@/components/parts/CommonPropertyCard';
import CommonButton from '@/components/parts/button/CommonButton';
import IsMobile from '@/plugins/isMobile';
import bg1 from '@/assets/main-visual-s.png';

export default {
  name: 'MainContents',
  mixins: [MixinUtil, MixinAPIs, IsMobile, Meta, BehaviorLogMixin],
  components: {
    CommonGoToTop,
    SchoolDistrictsListSearch,
    CommonButton,
    CommonAutoLink,
    CommonPropertyCard,
  },
  data() {
    return {
      bg: this.getBg(),
      preflist: [],
      arealists: {},
      favlist: [],
      compareRowList: [],
      compareList: [],
      isPreflist: true,
      citylist: [],
      isCitylist: true,
      isShowModal: false,
      isShowMovieModal: false,
      apiRaceToken: null,
      pref: '0',
      city: '0',
      prefilledCity: null,
      err: false,
      isCityReady: false,
      modifiableText: {},
      video: {
        video_heading: '',
        video_link: '',
        video_link_url: '',
        video_text: '',
        video_thumb_url: '',
        video_url: '',
        youtube_url: '',
      },
      sugguestProperties: [],
      isInsertTextReady: false,
      suggest: {
        data: {
          contents: [],
        },
      },
      blog: {
        new: {
          data: {
            contents: [],
          },
        },
        conv: {
          data: {
            contents: [],
          },
        },
        money: {
          data: {
            contents: [],
          },
        },
        question: {
          data: {
            contents: [],
          },
        },
        memberShip: {
          data1: {
            contents: [],
          },
          data2: {
            contents: [],
          },
        },
      },
    };
  },
  watch: {
    preflist() {
      this.isPreflist = false;
    },
    selectedPrefecture() {
      this.onChangePrefCD();
    },
    citylist() {
      this.isCitylist = false;
    },
  },
  filters: {
    manEn(value) {
      return `${Math.round(value / 10000)}万円`;
    },
  },
  computed: {
    selectedPrefecture: {
      set(newValue) {
        this.pref = newValue;
      },
      get() {
        const selectedPrefAvailable = this.preflist.find(a => a.pref_id === this.pref);
        return selectedPrefAvailable ? this.pref : '0';
      },
    },
    selectedCity: {
      set(newValue) {
        this.city = newValue;
      },
      get() {
        const selectedCityAvailable = this.citylist.find(a => a.city_code === this.city);
        return selectedCityAvailable ? this.city : '0';
      },
    },
    isBtnDisp() {
      return this.isMobile;
    },
    storedFavorite() {
      /* eslint dot-notaion: 0 */
      return this.$store.getters['getFavorite'];
    },
    storedCompare() {
      /* eslint dot-notaion: 0 */
      return this.$store.getters['getCompare'];
    },

  },
  async created() {
    await this.getUserLastSearchedArea();
    let lastPrefCode;
    let lastCityCode;
    if (this.pref === '0') {
      // 検索履歴なし
      lastPrefCode = 11;
      lastCityCode = 11211;
    } else if (this.pref !== '0' && this.prefilledCity === '0') {
      // 都道府県検索のみ
      lastPrefCode = this.pref;
      lastCityCode = 0;
    } else {
      //  pref,city両方存在する場合
      lastPrefCode = this.pref;
      lastCityCode = this.prefilledCity;
    }
    this.sugguestProperties = await this.getPlanePropertyList(3, lastPrefCode, lastCityCode);
    //  差し込みテキスト
    this.modifiableTextRow = await this.getModifiableTextList();
    this.modifiableText = {
      top1: this.modifiableTextRow.data.top1.split('\n'),
      top2: this.modifiableTextRow.data.top2.split('\n'),
      top3: this.modifiableTextRow.data.top3.split('\n'),
    };
    this.video = {
      video_heading: this.modifiableTextRow.data.video_heading,
      video_link: this.modifiableTextRow.data.video_link,
      video_link_url: this.modifiableTextRow.data.video_link_url,
      video_text: this.modifiableTextRow.data.video_text,
      video_thumb_url: this.modifiableTextRow.data.video_thumb.url,
      video_url: this.modifiableTextRow.data.video_url,
      youtube_url: this.getYoutubeUrl(this.modifiableTextRow.data.video_url),
    };
    this.isInsertTextReady = true;

    // 都道府県リスト取得
    this.preflist = await this.getPrefectureList(1, 0);
    this.arealists = {
      all: this.preflist,
      shinchiku: await this.getPrefectureList(1, 1),
      chuko: await this.getPrefectureList(1, 2),
    };
    // サジェスト？取得
    this.suggest = await this.getSuggestList(6);

    // ミツカルブログ取得
    this.blog.new = await this.getBlogList(1);
    this.blog.money = await this.getBlogList(2);
    this.blog.conv = await this.getBlogList(3);
    this.blog.question = await this.getBlogList(4);
    await this.setBlogMemberShip();

    const fullWishList = await this.retrieveFullWishList();
    // 比較リスト取得
    if (!this.storedCompare) {
      this.$store.commit('setCompare', []);
    } else {
      this.compareList = await this.storedCompare;
    }

    // 比較リスト作成
    this.compareRowList = await this.retrievePropertyData(fullWishList);
    this.compareRowList = this.compareRowList
      .filter(this.filterByProvidedDate)
      .filter(n => parseInt(n.oldPriceMin, 10) > n.newPriceMin)
      /* eslint array-callback-return: 0 */
      .map(n => ({
        id: n.id,
        registered: n.registered,
        oldPriceMin: n.oldPriceMin,
        oldPrice: n.oldPriceMax,
        newPriceMin: n.newPriceMin,
        newPrice: n.newPrice,
        newPriceMax: n.newPriceMax,
        addedDate: new Date(),
        name: n.name,
      }));
    this.compareRowList.forEach((item) => {
      this.updateWishListPrices(
        {
          oldPriceMin: item.newPriceMin,
          oldPriceMax: item.newPriceMax,
        },
        item.id,
      );
    });

    // 比較リスト未読チェック
    if (this.compareRowList.length > 0) {
      this.isShowModal = true;
      // filter old items that match new item ids (ある物件は一回のみ表示させる)
      const filteredCompareList = this.compareList.filter((item) => {
        const compareRowListIds = this.compareRowList.map(a => a.id);
        return !compareRowListIds.includes(item.id);
      });
      this.$store.commit('setCompare', [...this.compareRowList, ...filteredCompareList]);
      this.compareList = this.$store.getters['getCompare'];
    }

    // Footer表示フラグ更新
    await this.$store.commit('setFooterDisplayFlag');
  },
  mounted() {
    this.metaSetForIndex();
  },
  methods: {
    async getUserLastSearchedArea() {
      try {
        const lastSearchedArea = await this.getLastSearchedArea();
        this.pref = lastSearchedArea.prefId;
        this.prefilledCity = lastSearchedArea.cityId;
      } catch (e) {
        // not found, likely because doesn't exist yet
      }
    },
    async onChangePrefCD() {
      const requestedPref = this.pref;
      this.isCityReady = false;
      if (this.prefilledCity) {
        this.selectedCity = this.prefilledCity;
        this.prefilledCity = null;
      } else {
        this.selectedCity = 0;
      }
      this.citylist = await this.getCityList(1, this.selectedPrefecture, 0);
      if (this.selectedPrefecture === requestedPref) {
        this.isCityReady = true;
      }
    },
    updateChangedFavorites(favoritesList) {
      favoritesList.forEach((updatedItem) => {
        this.updateWishListPrices({
          oldPriceMin: updatedItem.newPriceMin,
          oldPriceMax: updatedItem.newPriceMax,
        });
      });
    },
    async retrievePropertyData(list) {
      const promises = list.map(async item => new Promise(async (resolve) => {
        try {
          const hoge = await this.getPropertyData(item.id);
          resolve({
            ...item,
            newPriceMin: hoge.data.price_min,
            newPriceMax: hoge.data.price_max,
            provided_at: hoge.data.provided_at,
            name: hoge.data.name,
          });
        } catch (e) {
          resolve(null);
        }
      }));
      const properties = await Promise.all(promises);
      return properties.filter(a => !!a);
    },
    getBg() {
      const rand = Math.floor(Math.random() * Math.floor(1));
      const bg = [bg1];
      return bg[rand];
    },
    onClickSearch() {
      const uri = '/kodate/area';
      if (this.pref === '0') {
        this.err = true;
      } else {
        // Cookies.set('searchPref', this.pref, {
        //   expires: 1 / 24,
        // });
        // Cookies.set('searchCity', this.city, {
        //   expires: 1 / 24,
        // });
        location.href =
          this.city !== 0 && this.city !== '0'
            ? `${uri}/${this.selectedPrefecture}/${this.city}/`
            : `${uri}/${this.selectedPrefecture}/`;
      }
    },
    filterByProvidedDate(n) {
      const limit = new Date();
      limit.setDate(limit.getDate() - 15);
      return new Date(n.provided_at) > limit;
    },
    async setBlogMemberShip() {
      const blogMemberShip = await this.getBlogList(5, 6);
      for (let index = 0; index < blogMemberShip.data.contents.length; index += 1) {
        if (index % 2 === 0) {
          this.blog.memberShip.data1.contents.push(blogMemberShip.data.contents[index]);
        } else {
          this.blog.memberShip.data2.contents.push(blogMemberShip.data.contents[index]);
        }
      }
    },
    openMovieModal() {
      this.isShowMovieModal = true;
    },
    closeMovieModal() {
      this.isShowMovieModal = false;
    },
    openMoviePage(e) {
      e.stopPropagation();
    },
    getYoutubeUrl(videoUrl) {
      const urlArray = videoUrl.split('/');
      const id = urlArray[urlArray.length - 1];
      return `https://www.youtube.com/embed/${id}`;
    },
  },
};

</script>

<style scoped lang="scss">
@charset "UTF-8";
@import "@/assets/style/modal_scss.scss";
.c-insertText {
  color:#666;
  &--top1 {
    &__text{
      text-align:center;
    }
    padding:10px;
  }
  &--top2 {
    padding:40px 10px 0px;
    &__text{
      text-align:center;
      padding:10px 0;
    }
  }
  &--top3 {
    background-color:#FAFAFA;
    padding: 40px 0;
    &__text{
      font-size:12px;
      width: 100%;
      max-width: 980px;
      margin: auto;
      line-height: 2em;
    }
  }
}
.c-main {
  background-color: #FFF;
  &--screen {
    width:100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 60% center;
    padding: 15% 0 18%;
    h1 {
      width:100%;
      text-align: center;
      font-size: 36px;
      margin: 0 auto;
      padding: 20px 0 90px;
      color:#000000;
      font-family: "游明朝", "YuMincho", "ヒラギノ明朝 ProN W6", "Hiragino Mincho ProN", "HG明朝E", "ＭＳ Ｐ明朝", "ＭＳ 明朝", serif;
      img {
        display: block;
        margin: 10px auto 0;
        width: 265px;
        height: 36px;
      }
    }
    &--area {
      width: 100%;
      max-width:730px;
      margin: 45px auto 0;
      position: relative;
      &--wrap {
        width: calc(100% - 65px);
        max-width: 660px;
        margin-right:55px;
        display:flex;
        position: relative;
        & > div {
          width: 50%;
          margin: 0 10px;
          height: 52px;
          background: rgba(255,255,255,0.6);
          border-radius: 10px;
          overflow: hidden;
          position: relative;
        }
        &__list {
            padding: 17px;
            width: 100%;
            height: 100%;
            font-size: 14px;
            border: 0;
            cursor: pointer;
            background-color: rgba(255,255,255,0.6);
            appearance: none;
                -webkit-appearance: none;
        }
        & > div:after {
          content:'';
          position:absolute;
          bottom: 12px;
          right: 12px;
          width: 25px;
          height: 25px;
          background-size: cover;
          background-image:url('/static/img/icon-sort-2.png');
          pointer-events: none;
        }
      }
      &--submit {
        background-color: #E83532;
        border-radius: 10px;
        width:52px;
        height:52px;
        display:flex;
        justify-content: center;
        align-items: center;
        position:absolute;
        right:10px;
        bottom:0;
        img {
          display:block;
          width:25px;
          height:25px;
        }
      }
    }
  }
  &--suggest {
    width:100%;
    h2 {
      margin: 40px auto 10px;
      line-height: 1.5em;
      font-size: 20px;
    }
    &--list {
      width:100%;
      max-width: 980px;
      margin: 40px auto;
      display:flex;
      justify-content: space-between;
      flex-wrap: wrap;
      &__itemWrapper:nth-child(-n+4) {
        margin-bottom:20px;
      }
      &__itemWrapper {
        width: calc(50% - 10px);
        margin-right: 10px;

        &:nth-child(even) {
          margin-right: 0;
          margin-left: 10px;
        }
      }
      &__item {
        height: 100%;
        padding: 20px;
        border: 1px solid #CCC;
        border-radius: 10px;
        display:flex;
        figure {
          width:160px;
          height:160px;
          border: 1px solid #CCC;
          display:flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          img {
            width:100%;
            height:100%;
            object-fit: contain;
          }
        }
        &__flex {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;

          span {
           margin: 10px 10px 10px 0;
          }
        }
        article {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width:280px;
          padding-left: 20px;
          overflow: hidden;
          h3 {
            font-size: 18px;
            line-height:1.5em;
            font-weight:bold;
          }
          p {
            margin-top:10px;
            line-height: 1.6em;
            font-weight:bold;
            overflow: hidden;
            width: 100%;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
          }
        }
      }
    }
    &--movie {
      width: 100%;
      max-width: 980px;
      margin: 40px auto;
      justify-content: space-between;
      flex-wrap: wrap;
      cursor: pointer;
      &__item {
        height: 100%;
        padding: 20px;
        border: 1px solid #CCC;
        border-radius: 10px;
        display:flex;
        figure {
          width:330px;
          height:240px;
          display:flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          img {
            width: 330px;
            height: 240px;
            object-fit: contain;
          }
        }
        &__flex {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;

          span {
           margin: 10px 10px 10px 0;
          }
        }
        article {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
          padding-left: 20px;
          overflow: hidden;
          h3 {
            font-size: 18px;
            line-height:1.5em;
            font-weight:bold;
          }
          p {
            margin-top:10px;
            line-height: 1.6em;
            font-weight:bold;
            overflow: hidden;
            width: 100%;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
          }
        }
        &--heading {
          color: red,
        }
      }
    }
  }
  &--school-search {
    background: #fafafa;
  }
  &--blog {
    width: 100%;
    max-width: 760px;
    margin: 40px auto 0;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    h2 {
      width:100%;
      line-height:1.3em;
      margin:0;
      font-weight:bold;
      font-size:18px;
      text-align: center;
    }
    &--box {
      width:100%;
      max-width:380px;
      margin-top: 30px;
      h3 {
        font-size: 16px;
        img {
          vertical-align:middle;
          width:24px;
          height:24px;
        }
      }
      &--list {
        margin-top:24px;
        li:not(:first-child) {
          margin-top:10px;
        }
        li {
          a {
            display: flex;
            figure {
              width: 100px;
              height: 65px;
              overflow: hidden;
              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
            article {
              width: calc(100% - 100px);
              max-width: 280px;
              margin-left: 10px;
              padding-right:20px;
              overflow:hidden;
              h4 {
                font-weight: bold;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;

              }
              p {
                font-size: 12px;
                margin-top: 6px;
                line-height: 1.5em;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
              }
            }
          }
        }
      }
    }
  }
  &--favarite-price-diff {
    width: 100%;
    max-width: 760px;
    margin: auto;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    h2 {
      width:100%;
      line-height:1.3em;
      margin:40px 0 0;
      font-weight:bold;
      font-size:18px;
      text-align: center;
    }
    &--list {
      width:100%;
      border: 1px solid #CCCCCC;
      background-color: white;
      border-radius: 14px;
      margin: 14px 20px;
      padding: 50px 20px;
      ul {
        li {
          line-height: 1.4em;;
          font-size: 14px;
          margin-bottom: 8px;
          display: flex;
          &:last-child {
            margin-bottom: 0;
          }
          p {
            padding-right: 20px;
            word-break: break-all;
          }
          p:last-child{
            margin-left: auto;
            float: right;
          }
        }
      }
      &--red{
       font-weight: bold;
      }
      &--red{
        color: #E83532;
      }
      &--date{
        white-space: nowrap;
      }
    }
  }
  &--nothing-favarite-price-diff {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &--favarite-price-diff-modal {
    &--modal-wrapper{
      background-color: rgba(255,255,255,0.74);
      z-index:2;
    }
    &--container {
      border-radius: 10px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    &--close {
        position: absolute;
        right: 10px;
        top: 10px;
        border: 1px solid #181717;
        border-radius: 18px;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 2;
        opacity: .6;
    }
    &--header {
      padding-bottom: 40px;
    }
    &--list {
      ul {
          li {
            line-height: 1.4em;
            font-size: 14px;
            margin-bottom: 8px;
            display: flex;
            p {
              padding-right: 20px;
            }
            p:last-child{
              margin-left: auto;
              float: right;
            }
            .row-flex {
              display: flex;
              flex-direction: row;
              position: relative;
              padding-right: 10px;
            }
          }
        }
        &--red{
          font-weight: bold;
        }
        &--red{
          color: #E83532;
        }
      &--icon {
        position: absolute;
        right: 0px;
        top: 0;
      }
    }
  }
  &--movie-modal {
    &--modal-wrapper{
      background-color: rgba(0, 0, 0, 0.74);
      z-index:2;
    }
    &--container {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 90%;
      margin: 0px auto;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.33);
      transition: all 0.3s ease;
      font-family: Helvetica, Arial, sans-serif;
      &--box {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 56.25%;
        overflow: hidden;
        // margin-bottom: 50px;
      }
      &--box iframe{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    &--container::before {
        height: (9/16)*100%;
    }
    &--movie-content {
      width: 100%;
      height: 100%;
    }
  }
  &--area {
    background-color: #FAFAFA;
    width:100%;
    padding: 20px;
    padding-top:30px;
    margin-top:40px;
    h4 {
      width: 100%;
      max-width: 500px;
      margin:auto;
      color: #E83532;
      font-weight: bold;
    }
    &--list {
      width: 100%;
      max-width: 500px;
      margin:20px auto;
      &__item {
        display:flex;
            margin-top: 20px;

        &__key {
          width:100px;
          font-weight: bold;
          line-height:1.7em;
        }
        &__value{
          width: calc(100% - 100px);

          &__list {
            display:flex;
            flex-wrap: wrap;
            &__item {
              margin-left:20px;
              line-height:1.7em;
            }
          }
        }
      }
    }
  }

  &--kind {
    background-color: #FAFAFA;
    width:100%;
    padding: 20px;
    padding-top:30px;
    margin-top: 30px;

    h4 {
      width: 100%;
      max-width: 775px;
      margin:auto;
      text-align: center;
      color: #E83532;
      font-weight: bold;
    }
    &--list {
      width: 100%;
      max-width: 775px;
      min-height: 178px;
      margin:20px auto;
      &__item:nth-child(n+2) {
        color:lightgray;
      }
      &__item {
        display:flex;
            margin-top: 20px;

        &__key {
          width:100px;
          font-weight: bold;
          line-height:1.7em;
        }
        &__value{
          width: calc(100% - 100px);

          &__list {
            display:flex;
            flex-wrap: wrap;
            &__item {
              margin-left:20px;
              line-height:1.7em;
            }
          }
        }
      }
    }
  }
  &__AreaList {
    width: 100%;
    max-width: 1118px;
    margin: 40px auto 0;

    &__heading {
      width: 100%;
      line-height: 1.3em;
      margin: 0;
      font-weight: bold;
      font-size: 18px;
      text-align: center;
    }
    &__list {
      display:flex;
      justify-content: center;
      margin-top:30px;
      &__item {
        margin:0 10px;
      }
    }
  }
  &__SugguestProperty {
    width: 100%;
    max-width: 1118px;
    margin: 40px auto 0;
    padding-bottom:40px;

    &__heading {
      width: 100%;
      line-height: 1.3em;
      margin: 0;
      font-weight: bold;
      font-size: 18px;
      text-align: center;
    }
    &__text {
      margin: 20px;
      text-align: center;
    }
    &__list {
      display:flex;
      justify-content: space-between;
    }
  }
  .modal-content-wrapper {
    max-height: 600px;
    overflow: scroll;
  }
}

@media screen and (max-width:999px){
  .c-insertText  {
    &--top2 {
      padding:30px 10px 0px;
      &__text{
        text-align:center;
        padding:10px 0;
      }
    }
    &--top3 {
      &__text{
        width: calc(100% - 40px);
      }
    }
  }
  .c-main--screen {
    padding: 15% 0 16%;
    h1 {
      font-size: 24px;
      img {
        width: 200px;
        height: 27px;
      }
    }
  }
  .c-main--suggest--list {
    justify-content: center;
    padding: 0 20px;
    margin-top:30px;
  }
  .c-main--suggest--list__item figure {
    width: 80px;
    height: 80px;
  }
  .c-main--suggest--list__item article {
    h3 {
      font-size: 16px;
    }
    p {
      margin-top: 5px;
      line-height: 1.5;
      font-weight: normal;
    }
  }
  .c-main--school-search {
    background-color: #FAFAFA;
    margin-top: 40px;

    .search-wrapper {
      width: 512px;
      margin: auto;
    }
  }
  .c-main--blog {
    padding: 0 20px;
    h2 {
      width: 100%;
    }
  }
  .c-main--blog--box {
    max-width: 360px;
  }
  .c-main--blog--box:nth-of-type(even) article {
    padding-right: 0;
  }
  .c-main--suggest--movie {
    justify-content: center;
    padding: 0 20px;
    margin-top:30px;
  }
  .c-main__SugguestProperty {
    padding-bottom: 0px;
    &__text {
      margin: 20px;
    }
    &__list {
      justify-content: space-evenly;
      flex-wrap: wrap;
      &__item:nth-child(3) {
        margin-top:20px;
      }
    }
  }
  .c-main--kind {
    margin-top: 20px;
  }
}

@media screen and (max-width:767px){
  .c-insertText  {
    &--top1 {
      padding:10px 20px;
      &__text{
        text-align:left;
      }
    }
    &--top2 {
      padding:30px 20px 0px;
      &__text{
        line-height:1.7em;
        padding: 0px;
        text-align:left;
      }
    }
  }
  .c-main {
    &--favarite-price-diff-modal {
      &--list {
        ul {
          li {
            flex-direction: column;
          }
        }
        &--icon {
          display: none;
        }
      }
    }
    &--screen {
      min-height: 211px;
      padding: 12% 0 6%;
      h1 {
        padding: 20px 0 40px;
        font-size: 14px;
        font-weight: bold;
        img {
          display: block;
          margin: 10px auto 0;
          width: 132px;
          height: 18px;
        }
      }
      &--area {
        margin: 25px auto 0;
      }
    }
    &--suggest {
      h2 {
        font-size: 14px;
        font-weight: bold;
        margin: 23px auto 0px;
      }
      &--list {
        width: calc(100% - 40px);
        padding: 0;
        margin-top: 20px;

        &__itemWrapper {
          margin: 0 0 10px 0 !important;
          width: 100%;
        }
        &__itemWrapper:last-child {
          margin-bottom: 0px !important;
        }
        &__item {
          width: 100%;
          padding: 10px;
          figure {
              width:80px;
              height:80px;
            img {
              width:100%;
            }
          }
          article {
            width: calc(100% - 60px);
            padding-left: 10px;
            h3 {
              line-height: 1.5;
              font-size: 16px;
            }
            p {
              margin-top: 5px;
              line-height: 1.4em;
              font-weight: normal;
              -webkit-line-clamp: 2;
            }
            span {
              bottom: 0;
              right:0;
              text-align: right;
            }
            a {
              display:none;
            }
          }
        }
      }
      &--movie {
        width: calc(100% - 40px);
        padding: 0;
        &__item {
          display: block;
          article {
            padding-left: 0;
            h3 {
              line-height: 1.5;
              font-size: 16px;
              margin-top:10px;
            }
            a {
               margin-top:10px;
            }
          }
          figure {
            width:100%;
            img {
              width: 100%;
            }
          }
        }
      }
    }
    &--school-search {
      margin-top: 30px;
      .search-wrapper {
        width: 100%;
        margin: auto;

      }
    }
    &--blog {
      padding: 0;
      h2 {
        margin-left: 20px;
      }
      &--merit {
        margin-bottom: 10px !important;
      }
      &--box {
        margin: 20px;
        max-width: 100%;
        h3 {
          img {
            vertical-align:middle;
          }
        }
        &--list {
          margin-top:12px;
          li:not(:first-child) {
            margin-top:10px;
          }
          li {
            a {
              display: flex;
              figure {
                img {
                width: 100%;
                }
              }
              article {
                max-width: 100%;
                padding-right: 0;
                h4 {
                  font-weight: bold;
                }
              }
            }
          }
        }
        &--nomargin {
          margin: 0 20px;
        }
      }
    }
  &--kind {
    h4 {
      text-align: left;
    }
    &--list {
      min-height:247px;
    }
  }
  &__AreaList {
    width: 100%;
    max-width: 1118px;
    margin: 40px auto 0;

    &__heading {
      width: 100%;
      line-height: 1.3em;
      margin: 0;
      font-weight: bold;
      font-size: 18px;
      text-align: center;
    }
    &__list {
      display:flex;
      justify-content: start;
      flex-wrap: wrap;
      padding: 0 10px;
      &__item {
        margin: 10px;
      }
    }
  }
  &__SugguestProperty {
    &__text {
      margin: 20px;
    }
    &__list {
      justify-content: space-evenly;
      flex-wrap: wrap;
      width: 346px;
      margin: auto;
      &__item {
        width:  100%;
      }
      &__item:nth-child(2) {
        margin-top:20px;
      }
      &__item:nth-child(3) {
        display: none;
      }
    }
  }
  }
  .modal-content-wrapper {
    max-height: 492px !important;
    overflow: scroll;
  }
}
@media (min-width: 1000px) {
  .c-main {
    &--movie-modal {
      &--container {
        width: 1000px;
        height: 500px;
      }
    }
  }
}

// @media screen and (max-width:480px){
//   .c-insertText--top1{
//       min-height: 34px;
//   }
//   .c-insertText--top2{
//       min-height: 76px;
//   }
//   .c-main__AreaList {
//       min-height: 121px;
//   }
//   .c-main__SugguestProperty {
//       min-height: 1363px;
//   }
//   .c-main--suggest {
//       min-height: 1252px;
//   }
//   .c-main--suggest--movie{
//       min-height: 462px;
//   }
//   .c-main--suggest--list {
//       min-height: 850px;
//   }
//   .c-main--school-search {
//       min-height: 397px;
//   }
//   .c-main--blog--top {
//       min-height: 605px;
//   }
//   .c-main--blog--bottom {
//       min-height: 262px;
//   }
//   .c-main--kind {
//       min-height: 351px;
//   }
//   .c-insertText--top3 {
//       min-height: 248px;
//   }
// }
</style>
